import { HugeiconsIcon } from "@hugeicons/react";
import type { CallEnd01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";

interface ControlButtonProps {
  label: string;
  onClick: () => void;
  circleClassName: string;
  icon: typeof CallEnd01Icon;
  // Set on controls that toggle a panel (Keypad) — the label stays put, so
  // aria-pressed is what tells a screen reader the pad is open.
  pressed?: boolean;
  disabled?: boolean;
}

export function ControlButton({
  label,
  onClick,
  circleClassName,
  icon,
  pressed,
  disabled
}: ControlButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={pressed}
      disabled={disabled}
      className={cx(
        "flex flex-col items-center gap-2",
        disabled && "cursor-not-allowed opacity-40"
      )}
    >
      <span
        className={cx(
          "grid size-12 place-items-center rounded-full transition",
          circleClassName
        )}
      >
        <HugeiconsIcon icon={icon} size={22} />
      </span>
      <span className="text-xs text-content-400">{label}</span>
    </button>
  );
}
